<template>
  <div class="page-content container">
    <h1 class="page-title pb-30">MY ACCOUNT</h1>

    <validation-observer ref="formuser">
      <user-form
        v-model="cloneUser"
        :editing="editing"
        settings="settings"
        @reset-password="save"
      ></user-form>
    </validation-observer>
  </div>
</template>

<script>
import UserForm from '@/components/forms/UserForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'UserSettings',
  components: {
    ValidationObserver,
    UserForm
  },

  data() {
    return {
      editing: true,
      settings: true,
      cloneUser: {}
    };
  },
  mounted() {
    this.cloneUser = _.cloneDeep(this.$store.state.user);
    this.cloneUser.oldPassword = '';
    this.cloneUser.newPassword = '';
  },
  methods: {
    save() {
      if (
        this.cloneUser.oldPassword != '' &&
        this.cloneUser.newPassword != ''
      ) {
        this.axiosRequest('post', 'Auth/ChangePassword', {
          password: this.cloneUser.oldPassword,
          newPassword: this.cloneUser.newPassword,
          confirmPassword: this.cloneUser.newPassword
        })
          .then(() => {
            this.showSuccessMessage('Password changed with success.');
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      }
    }
  }
};
</script>

<style lang="scss"></style>
